import { queryClient } from 'utils/ReactQueryClient';

export function removeCurrentUserQueries() {
  return queryClient.removeQueries(makeCurrentUserQueryKeyPrefix());
}

export function makeCurrentUserQueryKeyPrefix() {
  return ['current user'] as const;
}
